import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {ReportsService} from './reports.service';
import {CommonService} from '../../../shared/services/common.service';
import {Router} from '@angular/router';
import * as fromRoot from '../../../../state/app.state';
import {
  DownloadReportFailure,
  DownloadReportRequest,
  DownloadReportSuccess,
  FetchBehaviorTypeOptionsListFailure,
  FetchBehaviorTypeOptionsListRequest,
  FetchBehaviorTypeOptionsListSuccess,
  FetchClinicsOptionsListFailure,
  FetchClinicsOptionsListRequest,
  FetchClinicsOptionsListSuccess,
  FetchGeneratedReportsListFailure,
  FetchGeneratedReportsListRequest,
  FetchGeneratedReportsListSuccess,
  FetchGroupsOptionsListFailure,
  FetchGroupsOptionsListRequest,
  FetchGroupsOptionsListSuccess,
  FetchParticipantOptionsListFailure,
  FetchParticipantOptionsListRequest,
  FetchParticipantOptionsListSuccess,
  FetchQuestionnaireOptionsListFailure,
  FetchQuestionnaireOptionsListRequest,
  FetchQuestionnaireOptionsListSuccess,
  FetchReportsOptionsFailure,
  FetchReportsOptionsRequest,
  FetchReportsOptionsSuccess,
  GenerateNewReportsFailure,
  GenerateNewReportsRequest,
  GenerateNewReportsSuccess,
  RegenerateReportFailure,
  RegenerateReportRequest,
  RegenerateReportSuccess,
  StartReportPolling,
  StopReportPolling,
  UpdateReportStatus,
  CheckReportStatusRequest,
  CheckReportStatusSuccess,
  CheckReportStatusFailure
} from './reports.actions';
import {catchError, map, mergeMap, tap} from 'rxjs/operators';
import {of} from 'rxjs';
import {ReportPollingService} from './report-polling.service';

@Injectable()
export class ReportsEffects {
  fetchReportsOptions$ = createEffect(() => this.actions.pipe(ofType(FetchReportsOptionsRequest), map(action => action), mergeMap(payload => this.reportsService.getAllReportsOptions()
    .pipe(map(res => FetchReportsOptionsSuccess({payload: {list: res.data}})), catchError(err => of(FetchReportsOptionsFailure())), tap((action: any) => {
      if (action.type === FetchReportsOptionsSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchReportsOptionsFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    })))))

//fetch clinic list
  fetchClinicsOptions$ = createEffect(() => this.actions.pipe(ofType(FetchClinicsOptionsListRequest), map(action => {
    return action.payload
  }), mergeMap(payload => this.reportsService.getClinicsOptionsList({...payload})
    .pipe(map(res => FetchClinicsOptionsListSuccess({payload: {...res.data}})), catchError(err => of(FetchClinicsOptionsListFailure())), tap((action: any) => {
      if (action.type === FetchClinicsOptionsListSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchClinicsOptionsListFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    })))))

  //fetch groupList
  fetchGroupsOptions$ = createEffect(() => this.actions.pipe(ofType(FetchGroupsOptionsListRequest), map(action => {
    return action.payload
  }), mergeMap(payload => this.reportsService.getGroupsOptionsList(payload)
    .pipe(map(res => FetchGroupsOptionsListSuccess({payload: res.data})), catchError(err => of(FetchGroupsOptionsListFailure())), tap((action: any) => {
      if (action.type === FetchGroupsOptionsListSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchGroupsOptionsListFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    })))))

  //fetch behaviour type
  fetchBehaviorTypeOptions$ = createEffect(() => this.actions.pipe(ofType(FetchBehaviorTypeOptionsListRequest), map(action => {
    return action
  }), mergeMap(payload => this.reportsService.getBehaviorTypeOptionsList()
    .pipe(map(res => FetchBehaviorTypeOptionsListSuccess({payload: {list: res.data}})), catchError(err => of(FetchBehaviorTypeOptionsListFailure())), tap((action: any) => {
      if (action.type === FetchBehaviorTypeOptionsListSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchBehaviorTypeOptionsListFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    })))))

  //fetch participant type
  fetchParticipantOptionsList$ = createEffect(() => this.actions.pipe(ofType(FetchParticipantOptionsListRequest), map(action => {
    return action.payload
  }), mergeMap(payload => this.reportsService.getParticipantOptionsList(payload)
    .pipe(map(res => FetchParticipantOptionsListSuccess({payload: res.data})), catchError(err => of(FetchParticipantOptionsListFailure())), tap((action: any) => {
      if (action.type === FetchParticipantOptionsListSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchParticipantOptionsListFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    })))))

  //fetch questionnaire list
  fetchQuestionnairesOptionsList$ = createEffect(() =>
    this.actions.pipe(
      ofType(FetchQuestionnaireOptionsListRequest),
      map(action => null),
      mergeMap(payload =>
        this.reportsService.getQuestionnaireOptionsList()
          .pipe(
            map(response => {
                const {data} = response;

                return FetchQuestionnaireOptionsListSuccess({data})
              }
            ),
            catchError(err =>
              of(FetchQuestionnaireOptionsListFailure())
            ),
            tap((action: any) => {
              if (action.type === FetchQuestionnaireOptionsListSuccess.type) {
                // Code to execute on API Success Action dispatch
              } else if (action.type === FetchQuestionnaireOptionsListFailure.type) {
                // Code to execute on API Failure Action dispatch
              }
            })
          )
      )
    )
  )

  // generate reports
  GenerateReports$ = createEffect(() => this.actions.pipe(ofType(GenerateNewReportsRequest), map(action => action.payload), mergeMap(payload => {
    this.commonService.startLoading();
    return this.reportsService.generateReports(payload).pipe(map(response => {
      return GenerateNewReportsSuccess({ reportId: response.data?.reportId })
    }), catchError(err => of(GenerateNewReportsFailure())), tap((action: any) => {
      if (action.type === GenerateNewReportsSuccess.type) {
        // Code to execute on API Success Action dispatch
        this.commonService.notification('Report generation started. Please wait...', 'success');

        // Fetch the updated report list first
        this.store.dispatch(FetchGeneratedReportsListRequest({
          payload: {
            pageNumber: 1
          }
        }));
      } else if (action.type === GenerateNewReportsFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
      this.commonService.stopLoading();
    }))
  })))

  fetchGeneratedReportsList$ = createEffect(() => this.actions.pipe(ofType(FetchGeneratedReportsListRequest), map(action => action.payload), mergeMap(payload => {
    return this.reportsService.fetchGeneratedReports(payload).pipe(map((response: any) => {
      return FetchGeneratedReportsListSuccess({payload: response.data})
    }), catchError(err => of(FetchGeneratedReportsListFailure())), tap((action: any) => {
      if (action.type === FetchGeneratedReportsListSuccess.type) {
        // Code to execute on API Success Action dispatch
        // Auto-start polling for reports that are generating (status -1=Queued or 1=Pending)
        const reportsList = action.payload?.list || [];
        reportsList.forEach((report: any) => {
          if (report.status?.key === -1 || report.status?.key === 1) {
            // Check if not already polling
            if (!this.pollingService.isPolling(report.id)) {
              this.store.dispatch(StartReportPolling({ reportId: report.id }));
            }
          }
        });
      } else if (action.type === FetchGeneratedReportsListFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    }))
  })));

  downloadReport$ = createEffect(() => this.actions.pipe(ofType(DownloadReportRequest), map(action => action.payload),
    mergeMap(payload => {
      this.commonService.startLoading();
      return this.reportsService.downloadReports(payload).pipe(
        map(response => {
          // Stop polling for this report if active
          this.store.dispatch(StopReportPolling({ reportId: payload.reportId }));

          // Trigger actual file download
          if (response?.data?.url) {
            window.open(response.data.url, '_blank');
          }

          return DownloadReportSuccess();
        }),
        catchError(err => {
          this.commonService.notification(
            err?.error?.message || 'Failed to download report',
            'danger'
          );
          return of(DownloadReportFailure());
        }),
        tap((action: any) => {
          if (action.type === DownloadReportSuccess.type) {
            // Code to execute on API Success Action dispatch
            this.commonService.notification('Report downloaded successfully', 'success');
            // Note: Backend marks report as downloaded, so we refresh to get updated status
            this.store.dispatch(FetchGeneratedReportsListRequest({
              payload: {
                pageNumber: 1
              }
            }))
          } else if (action.type === DownloadReportFailure.type) {
            // Code to execute on API Failure Action dispatch
          }
          this.commonService.stopLoading();
        })
      )
    })))

  reGenerateReports$ = createEffect(() => this.actions.pipe(ofType(RegenerateReportRequest), map(action => action.payload),
    mergeMap(payload => {
      this.commonService.startLoading();
      return this.reportsService.reGenerateReports(payload).pipe(
        map(response => {
          return RegenerateReportSuccess();
        }),
        catchError(err => of(RegenerateReportFailure())),
        tap((action: any) => {
          if (action.type === RegenerateReportSuccess.type) {
            // Code to execute on API Success Action dispatch
            this.store.dispatch(FetchGeneratedReportsListRequest({
              payload: {
                pageNumber: 1
              }
            }))
          } else if (action.type === RegenerateReportFailure.type) {
            // Code to execute on API Failure Action dispatch
          }
          this.commonService.stopLoading();
        })
      )
    })))

  // Start polling when report generation begins
  startPolling$ = createEffect(() =>
    this.actions.pipe(
      ofType(StartReportPolling),
      tap(({ reportId }) => {
        this.pollingService.startPolling(
          { reportId, interval: 3000, maxDuration: 300000 },
          (id) => this.reportsService.checkReportStatus(id),
          (status) => {
            // Update the report status in store (this updates UI in real-time)
            this.store.dispatch(
              UpdateReportStatus({
                payload: {
                  reportId: status.id,
                  status: status.status
                }
              })
            );
          },
          () => {
            // Polling completed - no need to refresh list, status is already updated!
            // The UpdateReportStatus action above handles real-time UI updates
          },
          (error) => {
            // Handle polling error
            this.commonService.notification('Failed to check report status', 'danger');
          }
        );
      })
    ),
    { dispatch: false }
  );

  // Stop polling when requested
  stopPolling$ = createEffect(() =>
    this.actions.pipe(
      ofType(StopReportPolling),
      tap(({ reportId }) => {
        this.pollingService.stopPolling(reportId);
      })
    ),
    { dispatch: false }
  );

  // Check report status
  checkReportStatus$ = createEffect(() =>
    this.actions.pipe(
      ofType(CheckReportStatusRequest),
      map(action => action.payload),
      mergeMap(payload =>
        this.reportsService.checkReportStatus(payload.reportId).pipe(
          map(response => {
            return CheckReportStatusSuccess({ payload: response.data });
          }),
          catchError(err => of(CheckReportStatusFailure())),
          tap((action: any) => {
            if (action.type === CheckReportStatusSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === CheckReportStatusFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );

  constructor(
    private store: Store<fromRoot.State>,
    private reportsService: ReportsService,
    private actions: Actions,
    private commonService: CommonService,
    private router: Router,
    private pollingService: ReportPollingService
  ) {
  }
}
